export default "__VITE_ASSET__$JMIaU37__"